import router from '../index'
import store from '../../store'
import {isWechatBrowser, getAuthorizeUrl} from '../../utils/wx'
import {setLoginRoute} from '../../utils/api'
import {ROUTE_SWITCHING} from '../../store/mutation-types'

export default () => {
  router.beforeEach((to, from, next) => {
    /* 路由发生改变修改页面的title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    store.commit(ROUTE_SWITCHING, true)
    if (to.matched.some(m => m.meta.auth !== false) && !store.state.auth.authenticated) {
      setLoginRoute(to)
      if (isWechatBrowser()) {
        window.location.href = getAuthorizeUrl()  // 获取微信认证地址
      } else {
        next('/login')
      }
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/setup/before.js